import React from "react";
import styles from "../styles/landing.module.css";
import { Link, useNavigate } from "react-router-dom";

export default function LandingPage() {
    const router = useNavigate();

    const generateRandomRoom = () => {
        return Math.random().toString(36).substring(2, 10);
    };

    return (
        <div className={styles.landingPageContainer}>
            <nav className={styles.navbar}>
                <h2 className={styles.logo}>MeetMe</h2>

                <div className={styles.navlist}>
                    <span
                        className={styles.navAction}
                        onClick={() => router(`/${generateRandomRoom()}`)}
                    >
                        Join as Guest
                    </span>
                    <span onClick={() => router("/auth")}>Register</span>
                    <span onClick={() => router("/auth")}>Login</span>
                </div>
            </nav>

            <div className={styles.landingMainContainer}>
                <div>
                    <h1>
                        Meet anyone,
                        <br />
                        <span className={styles.accent}>instantly.</span>
                    </h1>

                    <p>One link. One click. Face-to-face.</p>

                    <div className={styles.ctaGroup}>
                        <div
                            className={styles.primaryBtn}
                            onClick={() => router(`/${generateRandomRoom()}`)}
                        >
                            Join as Guest
                        </div>
                        <div className={styles.secondaryBtn}>
                            <Link to="/auth">Get Started</Link>
                        </div>
                    </div>

                    <p className={styles.trustText}>
                        Peer-to-peer • No video stored • WebRTC powered
                    </p>

                    <p className={styles.valueLine}>
                        Secure peer-to-peer video calls — your media never
                        touches our servers.
                    </p>
                </div>

                <div>
                    <img src="/mobile.png" alt="MeetMe preview" />
                </div>
            </div>
        </div>
    );
}
